/**
 * @generated SignedSource<<c303374f0c50f23a2d3a09479ccf3887>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionsAndContent_AtlassianEditionAwareness$data = {
  readonly confluence_storage?: {
    readonly bytesUsed: AGG$Long;
  } | null | undefined;
  readonly jira?: {
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "actionsAndContent_AtlassianEditionAwareness";
};
export type actionsAndContent_AtlassianEditionAwareness$key = {
  readonly " $data"?: actionsAndContent_AtlassianEditionAwareness$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionsAndContent_AtlassianEditionAwareness">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "applicationKey"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckForStorageUsageConfluence"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckForStorageUsageJira"
    }
  ],
  "kind": "Fragment",
  "name": "actionsAndContent_AtlassianEditionAwareness",
  "selections": [
    {
      "condition": "shouldCheckForStorageUsageJira",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "applicationKey",
                  "variableName": "applicationKey"
                },
                (v0/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "attachmentStorageUsed"
            }
          ]
        }
      ]
    },
    {
      "condition": "shouldCheckForStorageUsageConfluence",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "ConfluenceStorage",
          "kind": "LinkedField",
          "name": "confluence_storage",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "bytesUsed"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "730ff8602078d945e5ec9b905eeeed0f";

export default node;
